// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HhsMedication {
    static getAttributeTypeMap() {
        return HhsMedication.attributeTypeMap;
    }
}
HhsMedication.discriminator = undefined;
HhsMedication.attributeTypeMap = [
    {
        "name": "productName",
        "baseName": "productName",
        "type": "HhsProduct"
    },
    {
        "name": "hasValidPrescription",
        "baseName": "hasValidPrescription",
        "type": "boolean"
    },
    {
        "name": "mailOrderOptIn",
        "baseName": "mailOrderOptIn",
        "type": "boolean"
    }
];
//# sourceMappingURL=hhsMedication.js.map